import { render, staticRenderFns } from "./RichTextWidget.vue?vue&type=template&id=c2b23e64&scoped=true"
import script from "./RichTextWidget.vue?vue&type=script&lang=js"
export * from "./RichTextWidget.vue?vue&type=script&lang=js"
import style0 from "./RichTextWidget.vue?vue&type=style&index=0&id=c2b23e64&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b23e64",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2b23e64')) {
      api.createRecord('c2b23e64', component.options)
    } else {
      api.reload('c2b23e64', component.options)
    }
    module.hot.accept("./RichTextWidget.vue?vue&type=template&id=c2b23e64&scoped=true", function () {
      api.rerender('c2b23e64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/viewer/templateWidgets/RichTextWidget.vue"
export default component.exports